import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-left-white.svg'
import _imports_1 from '@/app/ui/layout/sidebar/lllustrations/logo-genesis.svg'
import _imports_2 from '@/app/ui/assets/svg/noData_filter.svg'


const _hoisted_1 = { class: "h-screen bg-white border-r border-gray-lp-1300 absolute md:relative left-0 top-0 z-30" }
const _hoisted_2 = {
  key: 0,
  src: _imports_1,
  class: "w-auto h-8",
  alt: "logo"
}
const _hoisted_3 = {
  key: 1,
  class: "flex flex-row items-center relative w-full"
}
const _hoisted_4 = {
  key: 0,
  class: "flex flex-row gap-x-1.5 absolute bottom-0 left-17"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "bg-green-lp-100 px-1.5 py-0.5 text-white text-8px rounded-2xl" }, "Internal", -1)
const _hoisted_6 = {
  key: 0,
  class: "bg-gray-lp-1600 px-1.5 py-0.5 font-semibold text-gray-lp-800 rounded-2xl text-8px"
}
const _hoisted_7 = {
  class: "px-3 text-gray-lp-800 font-medium",
  style: {"font-size":"10px"}
}
const _hoisted_8 = { class: "relative w-full" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "absolute inset-y-0 left-0 flex items-center pl-3 text-black-lp-300 w-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-search" })
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "pi pi-times" }, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "flex flex-col gap-y-2 p-2"
}
const _hoisted_12 = {
  key: 1,
  class: "px-3 flex flex-col w-full justify-center"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-32 mx-auto mb-2",
  alt: "sidebar not found"
}, null, -1)
const _hoisted_14 = { class: "text-gray-lp-300 font-semibold text-center text-xs" }
const _hoisted_15 = { class: "text-gray-lp-800 text-center text-10px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardSisaSaldo = _resolveComponent("CardSisaSaldo")!
  const _component_CardSisaSaldoCod = _resolveComponent("CardSisaSaldoCod")!
  const _component_skeleton = _resolveComponent("skeleton")!
  const _component_SidebarItem = _resolveComponent("SidebarItem")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_CardReview = _resolveComponent("CardReview")!
  const _component_ModalFeedbackReview = _resolveComponent("ModalFeedbackReview")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("aside", {
      class: ["flex flex-col border-r border-gray-200 transition-all duration-300 gap-y-2 h-screen", _ctx.isCollapsed ? 'w-17' : 'w-64'],
      "aria-expanded": !_ctx.isCollapsed
    }, [
      _createVNode("button", {
        class: "bg-red-lp-2000 absolute z-10 rounded-full top-10 -right-3.5 p-2 items-center focus:outline-none expand",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapsed && _ctx.toggleCollapsed(...args)))
      }, [
        _createVNode("img", {
          src: _imports_0,
          class: ["transform transition-transform duration-300 w-3", { 'rotate-180': _ctx.isCollapsed }],
          alt: "left"
        }, null, 2)
      ]),
      _createVNode("div", {
        class: ["flex flex-row items-center border-b border-gray-lp-400 relative", {
          'px-2 py-2 mt-2 justify-center': _ctx.isCollapsed,
          'px-4 py-4': !_ctx.isCollapsed
        }]
      }, [
        (_ctx.isCollapsed)
          ? (_openBlock(), _createBlock("img", _hoisted_2))
          : (_ctx.accountData.account_type && !_ctx.isCollapsed && _ctx.logoSource)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("img", {
                  src: 
              require(`@/app/ui/layout/sidebar/lllustrations/logo-${_ctx.logoSource}.svg`)
            ,
                  class: ["mr-2", `${ _ctx.accountData.account_type === 'internal' ? 'w-40' : 'h-8 w-auto' }`],
                  alt: "logo"
                }, null, 10, ["src"]),
                (_ctx.accountData.account_type === 'internal')
                  ? (_openBlock(), _createBlock("div", _hoisted_4, [
                      _hoisted_5,
                      (_ctx.accountDivisionName)
                        ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.getDivisionName), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
      ], 2),
      _withDirectives(_createVNode("div", _hoisted_7, [
        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.currentVersion')) + " ", 1),
        _createVNode("button", {
          class: "outline-none text-red-lp-2000",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.prevVersion && _ctx.prevVersion(...args)))
        }, _toDisplayString(_ctx.$t('sidebar.revertToPreviousVersion')), 1)
      ], 512), [
        [_vShow, _ctx.permissionToggleVersionSidebarEnabled]
      ]),
      _createVNode("div", {
        class: ["flex-1 overflow-y-auto flex flex-col justify-start gap-y-2 pb-6", _ctx.isCollapsed ? 'w-17' : 'w-64'],
        style: {"padding-right":"1px"}
      }, [
        _createVNode(_component_CardSisaSaldo, {
          collapse: _ctx.isCollapsed,
          onClick: _ctx.onClickSisaSaldo
        }, null, 8, ["collapse", "onClick"]),
        _createVNode(_component_CardSisaSaldoCod, {
          collapse: _ctx.isCollapsed,
          onClick: _ctx.onClickSisaSaldoCod
        }, null, 8, ["collapse", "onClick"]),
        _createVNode("div", {
          class: `w-full ${!_ctx.isCollapsed ? 'px-3' : 'px-4'}`
        }, [
          _createVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.search = $event)),
              onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args))),
              placeholder: _ctx.$t('sidebar.searchMenuPlaceholder'),
              class: "pl-10 w-full bg-gray-lp-1000 rounded-lg py-2 outline-none text-10px font-medium placeholder-gray-lp-600 text-black-lp-200",
              name: "search",
              autocomplete: "off"
            }, null, 40, ["placeholder"]), [
              [_vModelText, _ctx.search]
            ]),
            (_ctx.search && !_ctx.isCollapsed)
              ? (_openBlock(), _createBlock("span", {
                  key: 0,
                  class: "absolute inset-y-0 right-4 flex items-center pr-3 text-red-lp-2000 w-3 cursor-pointer",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args)))
                }, [
                  _hoisted_10
                ]))
              : _createCommentVNode("", true)
          ])
        ], 2),
        (!_ctx.menu.length && !_ctx.isCollapsed && !_ctx.search)
          ? (_openBlock(), _createBlock("div", _hoisted_11, [
              _createVNode(_component_skeleton, { height: "1.5rem" }),
              _createVNode(_component_skeleton, { height: "1.5rem" }),
              _createVNode(_component_skeleton, { height: "1.5rem" })
            ]))
          : (!_ctx.menu.length && !_ctx.isCollapsed && _ctx.search)
            ? (_openBlock(), _createBlock("div", _hoisted_12, [
                _hoisted_13,
                _createVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('sidebar.menuNotFound')), 1),
                _createVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('sidebar.menuNotFoundDescription')), 1),
                _createVNode("button", {
                  class: "w-full py-2 mt-2 rounded-md border border-red-lp-2000 text-red-lp-2000 text-center text-xs font-semibold",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args)))
                }, _toDisplayString(_ctx.$t('sidebar.back')), 1)
              ]))
            : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                _createVNode(_component_Accordion, {
                  id: "sidebar-v2",
                  key: _ctx.isCollapsed,
                  multiple: "",
                  activeIndex: _ctx.activeIndexMenu,
                  class: "flex flex-col"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.menu, (item) => {
                      return (_openBlock(), _createBlock(_component_AccordionTab, {
                        key: item.label
                      }, {
                        header: _withCtx(() => [
                          _createVNode(_component_SidebarItem, {
                            active: _ctx.isActiveHeader(item),
                            data: item,
                            "is-collapsed": _ctx.isCollapsed,
                            open: _ctx.expandMenu[_ctx.getItemKey(item)],
                            onClick: _ctx.onClickParentMenu
                          }, {
                            "sub-menu": _withCtx(({ close }) => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.children, (child) => {
                                return (_openBlock(), _createBlock(_component_SidebarItem, {
                                  key: child.to,
                                  active: _ctx.isActiveChild(child.to, child.label),
                                  data: child,
                                  onClick: () => _ctx.selectSubMenu(child, close)
                                }, null, 8, ["active", "data", "onClick"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["active", "data", "is-collapsed", "open", "onClick"])
                        ]),
                        default: _withCtx(() => [
                          (item.children?.length && !_ctx.isCollapsed)
                            ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(item.children, (child, index) => {
                                return (_openBlock(), _createBlock(_component_SidebarItem, {
                                  key: child.to,
                                  active: _ctx.isActiveChild(child.to, child.label),
                                  data: child,
                                  tree: "",
                                  last: index === item.children.length - 1,
                                  index: index,
                                  "is-collapsed": _ctx.isCollapsed,
                                  onClick: ($event: any) => (_ctx.setActive(child.to, child.label))
                                }, null, 8, ["active", "data", "last", "index", "is-collapsed", "onClick"]))
                              }), 128))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["activeIndex"]),
                _createVNode(_component_CardReview, { collapse: _ctx.isCollapsed }, null, 8, ["collapse"])
              ], 64))
      ], 2)
    ], 10, ["aria-expanded"]),
    _createVNode(_component_ModalFeedbackReview)
  ]))
}